import { useEffect } from 'react';
import UserAuthTemplate from 'templates/UserAuthTemplate';

const SignInPage = () => {
    useEffect(() => {
        document?.querySelector('body').classList.add('auth-design');
        return () => {
            document?.querySelector('body').classList.remove('auth-design');
        };
    }, []);

    return (
        <div>
            <UserAuthTemplate />
        </div>
    );
};

export default SignInPage;
